/**
 * PROSHOP — Compteur animé au scroll.
 *
 * Tout élément `[data-count="N"]` s'anime de 0 → N quand il entre dans le viewport
 * (IntersectionObserver, une seule fois). Préfixe optionnel via `data-count-prefix`
 * (ex. « + »). Valeur finale déjà présente dans le HTML → dégradation propre si pas de JS
 * ou `prefers-reduced-motion`.
 */
document.addEventListener('DOMContentLoaded', () => {
    const els = document.querySelectorAll('[data-count]');
    if (!els.length) {
        return;
    }

    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || ! ('IntersectionObserver' in window)) {
        return; // on laisse la valeur finale telle quelle
    }

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const run = (el) => {
        const target = parseInt(el.dataset.count, 10);
        if (isNaN(target)) {
            return;
        }
        const prefix   = el.dataset.countPrefix || '';
        const duration = 1300;
        let startTime  = null;

        const step = (now) => {
            if (startTime === null) {
                startTime = now;
            }
            const progress = Math.min((now - startTime) / duration, 1);
            el.textContent = prefix + Math.round(easeOutCubic(progress) * target);
            if (progress < 1) {
                requestAnimationFrame(step);
            }
        };
        requestAnimationFrame(step);
    };

    const io = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                run(entry.target);
                obs.unobserve(entry.target);
            }
        });
    }, { threshold: 0.4 });

    els.forEach((el) => io.observe(el));
});
